import * as React from 'react'
import * as styles from './Summary.module.scss'

export const Summary = ({ title, synopsis }: { title?: string, synopsis?: string }) => (
    <div className={styles.summary}>
        <h1 className={styles.title}>
            {title}
        </h1>
        <p className={styles.synopsis}>
            {synopsis}
        </p>
    </div>
)